// i18next setup — website copy of the customer-web / kiosk pattern (spec 65 +
// ADR-006), trimmed for a public marketing SPA:
//
//   * SUPPORTED_LOCALES / DEFAULT_LOCALE come from @novemai/i18n-sdk so a
//     locale registration in the SDK propagates here automatically.
//   * tr-TR is the default UI language — the mockup copy is Turkish-first
//     and the launch market is TR (ADR-014 §6). en-US stays the SDK
//     source/fallback locale (missing-key fallback). The footer language
//     switch flips between the two at runtime (changeLanguage).
//   * No browser-preference detection: a deterministic default keeps the
//     first paint stable; the user picks the other locale explicitly — and
//     that choice is now REMEMBERED across reloads (readStoredLocale).

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import {
  DEFAULT_LOCALE,
  readStoredLocale,
  SUPPORTED_LOCALES,
  type LocaleCode,
} from "@novemai/i18n-sdk";

import enUS from "./locales/en-US.json";
import trTR from "./locales/tr-TR.json";

import { localeStorage } from "./locale-storage.ts";

export { DEFAULT_LOCALE, SUPPORTED_LOCALES };
export type { LocaleCode };

/** Default UI locale — Turkish-first marketing surface. */
export const WEBSITE_DEFAULT_LOCALE: LocaleCode = "tr-TR";

/**
 * Ziyaretçinin footer'daki seçimi. Seçici baştan beri vardı ama seçim hiçbir
 * yere yazılmıyordu: EN'e geçen ziyaretçi bir sonraki sayfada Türkçe'ye
 * dönüyordu. Tarayıcı dili BİLİNÇLİ olarak okunmaz — pazarlama yüzeyi
 * TR-first açılır, İngilizce açık bir tercihtir.
 */
function detectInitialLocale(): LocaleCode {
  return readStoredLocale(localeStorage) ?? WEBSITE_DEFAULT_LOCALE;
}

export async function initI18n(): Promise<typeof i18n> {
  if (i18n.isInitialized) return i18n;
  await i18n.use(initReactI18next).init({
    lng: detectInitialLocale(),
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: [...SUPPORTED_LOCALES],
    defaultNS: "common",
    ns: ["common"],
    resources: {
      "en-US": { common: enUS },
      "tr-TR": { common: trTR },
    },
    interpolation: {
      // React already escapes — i18next double-escape causes mojibake.
      escapeValue: false,
    },
    returnEmptyString: false,
    returnNull: false,
  });
  return i18n;
}

export { i18n };
export default i18n;
